import { useTranslation } from "react-i18next";
import { LocalizedText } from "@shared/praxis-config";

export const useLocalizedText = (text: LocalizedText): string => {
  const { i18n } = useTranslation();
  return text[i18n.language as keyof LocalizedText] ?? text.de;
};
